export enum InputType {
    CURRENCY = 'CURRENCY',
    SIN = 'SIN',
    NAME = 'NAME',
}
